<div
  class="text-day-text-icons-main dark:text-night-text-icons-main bg-day-bg-bg-main dark:bg-night-bg-bg-main dark:border-night-border-border-main border-day-border-border-main flex flex-row items-center rounded-t-xl"
  [ngClass]="[
    leadingIcon ? 'pl-3' : 'pl-4',
    trailingIcon ? 'pr-3' : 'pr-4',
    withBottomBorder ? 'border-b' : 'border-b-0'
  ]"
  [class.py-3]="trailingIcon || leadingIcon"
  [class.py-4]="!trailingIcon && !leadingIcon"
>
  @if (leadingIcon) {
    <dev-portal-action-button (click)="clickLeading.next()" [icon]="leadingIcon"></dev-portal-action-button>
  }

  <div
    class="oneinch-text-heading-h3 flex-1 cursor-default"
    [ngClass]="titleAlignment === 'center' || leadingIcon ? 'text-center' : 'text-left'"
  >
    {{ title }}
  </div>

  @if (trailingIcon) {
    <dev-portal-action-button (click)="clickTrailing.next()" [icon]="trailingIcon"></dev-portal-action-button>
  }
</div>
